import script from "./SeasonWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SeasonWidget.vue?vue&type=script&setup=true&lang=js"

import "./SeasonWidget.vue?vue&type=style&index=0&id=5186cec0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5186cec0"]])

export default __exports__